import * as React from "react";
import { observer } from "mobx-react-lite";
import { onError } from "src/common/onError";
import { Spin } from "antd";
import { ImageCarousel } from "src/components/ImageCarousel";
import { Mc2EntityStore } from "../Mc2EntityStore";

interface PropsMc2ImageInternal {
  store: Mc2EntityStore;
}

export const Mc2ImageInternal: React.FC<PropsMc2ImageInternal> = observer(
  ({ store }) => {
    const [wait, setWait] = React.useState(false);
    const [images, setImages] = React.useState<string[]>([]);
    const loadImages = () => {
      setWait(true);
      store
        .getImages()
        .then((newImages) => {
          setImages(newImages ?? []);
        })
        .finally(() => setWait(false))
        .catch(onError);
    };
    React.useEffect(() => {
      loadImages();
    }, []);

    const onChange = (newValue: string[]) => {
      setWait(true);
      store
        .saveImages(newValue)
        .then((newImages) => {
          setImages(newImages);
        })
        .finally(() => setWait(false))
        .catch(onError);
    };

    return (
      <Spin spinning={wait}>
        <ImageCarousel
          multiple
          maxCount={10}
          disabled={wait}
          value={images}
          onChange={onChange}
        />
      </Spin>
    );
  },
);
